<template>
    <Menu as="div" class="relative inline-block text-left">
      <div>
        <MenuButton
          :key="selectionUpdated"
          class="w-[125px] h-[24px] flex justify-between items-center rounded px-2 bg-[#F4F4F4] hover:bg-[#E5F2EA] hover:text-[#2A8176]"
          >
          <span
            :style="{'fontFamily': currentStyleFontFamily()}"
            class="text-sm font-medium text-gray-700 truncate text-left inline-block"
          >
            {{ loaded ? currentFontFamily() : '...' }}
          </span>
          <span class="inline-block w-4 h-4" v-html="dropdownIcon" />
        </MenuButton>
      </div>
  
      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
        <MenuItems class="w-[150px] max-h-[195px] absolute right-0 z-10 mt-2 origin-top-right rounded bg-white shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div class="py-1">
            <MenuItem @click="() => applyFont(value)" v-for="value, index in fontFamilies" :key="index" v-slot="{ active }">
              <a href="#" :class="[active ? 'bg-[#F4F4F4]' : 'bg-white', 'text-gray-700 block px-4 py-1 text-sm truncate', {'font-semibold bg-[#E5F2EA]': isFontSeleted(value)} ]" :style="{'fontFamily': value}">
                {{ capitalizeFirstLetterEveryWord(value.replaceAll('"',  '').split(',')[0]) }}
              </a>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
  </template>
  
<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

// import stores
import { fontFamilies } from '../../store/builder-style.store'
import { useBuilderStyles } from '../../store/builder-style.store';
import { useBuilder } from '../../store/builder.store';
import { useTiptapStore } from '../../store/tiptap.store'

// import helpers
import { capitalizeFirstLetterEveryWord } from '../../utils/helpers'
import { storeToRefs } from 'pinia'

const dropdownIcon = '<svg class="won-color-gray stroke-2 w-4 h-4" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_1_26114)"> <path d="M3.5 5L6 7.5L8.5 5H3.5Z" fill="#686E77"/> </g> <defs> <clipPath id="clip0_1_26114"> <rect width="12" height="12" fill="white"/> </clipPath> </defs> </svg>'

const tiptap = useTiptapStore()
const { editor, selectionUpdated } = storeToRefs(tiptap)

const builderStyles = useBuilderStyles()
const builder = useBuilder()

const { loaded } = storeToRefs(builder)

const currentSelectionIsEmpty = () => (editor.value ? editor.value.view.state.selection.empty : true)

const isFontSeleted = font => {
   return !currentSelectionIsEmpty()
      ? editor.value.isActive('textStyle', { fontFamily: font.replaceAll('"',  '') })
      : font==builderStyles.fontFamily
}

const currentStyleFontFamily = () => {
  return !currentSelectionIsEmpty()
    ? editor.value.getAttributes('textStyle')?.fontFamily ?? builderStyles.fontFamily
    : builderStyles.fontFamily
}

const currentFontFamily = () => {
  let currentSelectedTextFontFamily = editor?.value?.getAttributes('textStyle')?.fontFamily?.replaceAll('"',  '')?.split(',')[0]

  return !currentSelectionIsEmpty() 
    ? currentSelectedTextFontFamily ?? builderStyles.currentFontFamily
    : builderStyles.currentFontFamily
}

const applyFont = (value) => {
    // if not selected text than apply globally
    if(currentSelectionIsEmpty()) return builderStyles.applyFont(value)
    if(! editor.value) return
    
    // if selected text than apply font to selected text
    editor.value.chain().focus().setFontFamily(value.replaceAll('"','')).run()
}
</script>